import { render, staticRenderFns } from "./LayoutSection.vue?vue&type=template&id=b402438c&scoped=true"
import script from "./LayoutSection.vue?vue&type=script&lang=ts"
export * from "./LayoutSection.vue?vue&type=script&lang=ts"
import style0 from "./LayoutSection.vue?vue&type=style&index=0&id=b402438c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b402438c",
  null
  
)

export default component.exports